module.exports = "/_next/static/images/red_heart-32c3c867cfc949497f11254dfd3b962a.png";